/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useId } from 'react';

/**
 * Ed, the PowerAlpha engineer agent: round gradient badge with a hard hat breaking its top edge
 * (Figma "Ed · concept B variations", B4). Inline so each instance gets its own gradient id.
 */
function EdAvatar({ size = 26, title }: Readonly<{ size?: number; title?: string }>) {
  const gradientId = `ed-avatar-${useId()}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      style={{ flexShrink: 0, display: 'block' }}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#38BDF8" />
          <stop offset=".6" stopColor="#818CF8" />
          <stop offset="1" stopColor="#C084FC" />
        </linearGradient>
      </defs>
      <circle cx="48" cy="50" r="44" fill={`url(#${gradientId})`} />
      <path d="M20 42c0-16 12.5-27 28-27s28 11 28 27z" fill="#F7C738" />
      <rect x="14" y="40" width="68" height="9" rx="4.5" fill="#F7C738" />
      <rect x="45" y="15" width="6" height="18" rx="3" fill="#E5B42F" />
      <circle cx="38" cy="62" r="4.5" fill="#fff" />
      <circle cx="58" cy="62" r="4.5" fill="#fff" />
      <path
        d="M38 72c5.5 5 14.5 5 20 0"
        stroke="#fff"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default EdAvatar;
